export default __webpack_public_path__ + "static/media/babiesKids.a610f376.svg";